<div class="block">
    <p-splitter
        [panelSizes]="[17, 90]"
        [minSizes]="[12, 70]"
        styleClass="col-12">

        <ng-template pTemplate>
            <div class="w-full">
                <app-signature-navigation
                    class="w-full"
                    (activeRightContentEvent)="changeRightContent($event)"
                    (signEvent)="sign($event)"
                    [loggedInUserData]="loggedInUserData"
                    [userSubscription]="userSubscription">
                </app-signature-navigation>
            </div>
        </ng-template>

        <ng-template pTemplate>
            <div class="flex flex-column w-full">
                <div class="flex flex-column align-items-end w-full px-3">
                    <p-button styleClass="w-15rem" [label]="'sipo.sign' | translate" (click)="sign($event)"></p-button>
                </div>
                <div>
                    <div *ngIf="activeRightContent === 'home'" class="w-full">
                        <app-right-content class="w-full"></app-right-content>
                        <!--                        <app-sign-task-details></app-sign-task-details>-->
                    </div>
                    <div *ngIf="activeRightContent === 'profile-data'" class="w-full">
                        <app-profil-data class="w-full"></app-profil-data>
                    </div>
                    <div *ngIf="activeRightContent === 'signature-standards'" class="w-full">
                        <app-signature-standards
                            class="w-full"
                            [userSubscription]="userSubscription">
                        </app-signature-standards>
                    </div>
                    <div *ngIf="activeRightContent === 'visual-signature'" class="w-full">
                        <app-visual-signature class="w-full"></app-visual-signature>
                    </div>
                    <div *ngIf="activeRightContent === 'signature-settings'" class="w-full">
                        <app-signature-settings class="w-full"></app-signature-settings>
                    </div>
                    <div *ngIf="activeRightContent === 'faq'" class="w-full">
                        <app-faq></app-faq>
                    </div>
                </div>
            </div>
        </ng-template>

    </p-splitter>


</div>
